<template>
    <div id="compensation-dispute-list-filters-modal" class="modal fade" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Filter Compensation Disputes</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body px-0">
                    <div v-if="message" class="alert alert-danger" role="alert">{{ message }}</div>

                    <!-- Milestone -->
                    <div class="px-3 pb-3 border-bottom">
                        <div class="d-flex justify-content-between">
                            <div class="font-weight-bold">Milestone</div>
                            <div class="text-muted">
                                {{ comparisonOptions.find(x => x.value === filters.milestoneOperator).name }}
                                {{ milestoneName }}
                                <span class="pl-3" @click="milestoneToggle = !milestoneToggle"><i :class="['fas', milestoneToggle ? 'fa-chevron-up' : 'fa-chevron-down', 'fa-lg']"></i></span>
                            </div>
                        </div>
                        <div v-if="milestoneToggle" class="d-flex flex-wrap justify-content-start mt-2">
                            <div class="mr-3">
                                <select class="custom-select custom-select-sm" v-model="filters.milestoneOperator">
                                    <option v-for="milestoneOperator in milestoneOperators" :key="'compensation-dispute-list-filters-milestone-operator-' + milestoneOperator.value" :value="milestoneOperator.value">{{ milestoneOperator.name }}</option>
                                </select>
                            </div>
                            <div class="mr-3">
                                <select class="custom-select custom-select-sm" v-model="filters.milestone">
                                    <option v-for="milestoneOption in milestoneOptions" :key="'compensation-dispute-list-filters-tag-inclusion-option-' + milestoneOption.value" :value="milestoneOption.value">{{ milestoneOption.name }}</option>
                                </select>
                            </div>                          
                        </div>
                    </div>                 

                    <!-- Document Tag -->
                    <div class="px-3 pt-3">
                        <div class="d-flex justify-content-between">
                            <div class="font-weight-bold">Tag</div>
                            <div class="text-muted">
                                {{ tagInclusionOptions.find(x => x.value === this.filters.tagInclusion).name }}
                                {{ filters.tag }}
                                <span class="pl-3" @click="tagToggle = !tagToggle"><i :class="['fas', tagToggle ? 'fa-chevron-up' : 'fa-chevron-down', 'fa-lg']"></i></span>
                            </div>
                        </div>
                        <div v-if="tagToggle" class="d-flex flex-wrap justify-content-start mt-2">
                            <div class="mr-3">
                                <select class="custom-select custom-select-sm" v-model="filters.tagInclusion">
                                    <option v-for="tagInclusionOption in tagInclusionOptions" :key="'compensation-dispute-list-filters-tag-inclusion-option-' + tagInclusionOption.value" :value="tagInclusionOption.value">{{ tagInclusionOption.name }}</option>
                                </select>
                            </div>
                            <div class="mr-3">
                                <select class="custom-select custom-select-sm" v-model="filters.tag">
                                    <option v-for="tagOption in tagOptions" :key="'compensation-dispute-list-filters-tag-inclusion-option-' + tagOption.replace(/\s+/g, '-').toLowerCase()" :value="tagOption">{{ tagOption }}</option>
                                </select>
                            </div>                        
                        </div>
                    </div>                                                                                  

                </div>
                <div class="modal-footer">
                    <a href="javascript:void(0)" class="mr-auto" @click="reset">Reset Filters</a>
                    <button type="button" class="btn btn-primary" @click="apply()">Apply</button>
                </div>
            </div>
        </div>
    </div>                          
</template>

<script>
export default {
    data() {
        return {
            filters: {
                milestoneOperator: '=',
                milestone: 'any',
                tagInclusion: 'include',
                tag: 'Any'                
            },
            filter: Function,
            message : null,
            comparisonOptions: [
                { value: '=', name: '= Equal To'},
                { value: '<', name: '< Less Than'},
                { value: '>', name: '> Greater Than'},
                { value: 'between', name: 'Between'}
            ],            
            milestoneToggle: false,
            milestoneOptions:  [],
            tagInclusionOptions: [
                { value: 'include', name: 'Include' },
                { value: 'exclude', name: 'Exclude' }
            ],           
            tagToggle: false,
            tagOptions: []            
        }
    },
    computed: {
        milestoneOperators: function () {

            // between comparison operator not used for milestone filtering
            return this.comparisonOptions.filter(e => e.value !== 'between');
        },        
        milestoneName: function () {
            
            let milestone = this.milestoneOptions.find(x => x.value === this.filters.milestone);
            return milestone ? milestone.name : null;
        }
    },
   methods: {
        show: function (filters, callback) {

            this.filters = filters;
            this.filter = callback;

            axios.get('/ajax/attorney/legal-disputes/filters')
                .then(response => {

                    this.milestoneOptions = response.data.milestone_options;
                    this.tagOptions = response.data.tag_options;

                    // if the tag we are currently filtering on has been deleted clear the tag filter
                    if (!this.tagOptions.some(t => t.toLowerCase() === this.filters.tag.toLowerCase())) {
                        this.filtes.tagInclusion = 'inlcude';
                        this.filters.tag = 'Any';
                    }

                    $('#compensation-dispute-list-filters-modal').modal('show');
                })
                .catch(error => {
                    console.log(error.response);
                })
        },
        reset: function () {
            this.filters.milestoneOperator = '=';
            this.filters.milestone = 'any';
            this.filters.tagInclusion = 'include';
            this.filters.tag = 'Any';                                
        },
        apply: function () {
            $('#compensation-dispute-list-filters-modal').modal('hide');
            this.filter(this.filters);
        }
    },
    created() {
        eventHub.$on('show-compensation-dispute-list-filters', this.show);
    },
    beforeDestroy() {
        eventHub.$off('show-compensation-dispute-list-filters');
    }        
}
</script>

<style scoped>

</style>